import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center bg-emerald-dark text-white overflow-hidden" data-id="element-54">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-dark via-emerald-brand to-emerald-dark opacity-95" data-id="element-55" />
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }} data-id="element-56" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-24 w-full" data-id="element-57">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-59">
            <div className="inline-flex items-center gap-2 bg-gold-brand/20 text-gold-brand px-4 py-2 rounded-full border border-gold-brand/30" data-id="element-60">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-61" />
              <span className="text-sm font-semibold tracking-wide uppercase font-body" data-id="element-62">
                Edición Exclusiva — Comunidad Hispana de USA
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold leading-tight" data-id="element-63">
              ¿Cansado del Ardor que{' '}
              <span className="text-gold-brand" data-id="element-64">No Te Deja Dormir?</span>
            </h1>

            <p className="text-xl sm:text-2xl font-body font-light leading-relaxed text-emerald-light/90" data-id="element-65">
              Descubre el{' '}
              <strong className="text-gold-brand font-semibold" data-id="element-66">
                Protocolo SOS de 12 Minutos
              </strong>{' '}
              que miles de hispanos en USA están usando para apagar el fuego de
              la neuropatía diabética.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-67">
              <button onClick={() => {
              const el = document.getElementById('pricing');
              if (el) el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="text-center bg-gold-brand hover:bg-yellow-600 text-charcoal font-bold text-xl py-5 px-8 rounded-xl shadow-xl shadow-gold-brand/20 transition-all hover:scale-105 inline-flex items-center justify-center gap-3 cursor-pointer" data-id="element-68">
                ¡Quiero Mi Copia Ahora!
                <ArrowDownIcon className="w-5 h-5 animate-bounce" data-id="element-69" />
              </button>
            </div>

            <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm sm:text-base text-emerald-light/70 font-body" data-id="element-70">
              <span data-id="element-71">✓ Descarga inmediata</span>
              <span className="hidden sm:inline" data-id="element-72">•</span>
              <span data-id="element-73">✓ Formato digital</span>
              <span className="hidden sm:inline" data-id="element-74">•</span>
              <span data-id="element-75">✓ Garantía de 30 días</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40,
          rotate: 3
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: -2
        }} transition={{
          duration: 0.9,
          delay: 0.2
        }} className="flex justify-center lg:justify-end" data-id="element-76">
            <div className="relative max-w-sm w-full" data-id="element-77">
              <div className="absolute -inset-6 bg-gold-brand/15 rounded-3xl blur-2xl" data-id="element-78" />
              <img src="https://cdn.magicpatterns.com/uploads/ekytRGEXuK68sJycWWuQ9m/75c6ccc3-9dc9-4e00-8f5e-6eb8271880a7.jpg" alt="Portada del libro Protocolo SOS: Neuropatía y Pie Diabético" className="relative w-full rounded-lg shadow-2xl border-4 border-white/10" data-id="element-79" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}